import { useEffect, useState } from "react";
import Container from "../../UI/Container";
import { Grid, Paper, TablePagination, Typography } from "@mui/material";
import { errorMessage } from "../../../util/ConfirmAlertUtil";
import { findCatracaRegistroAll } from "../api-catraca-registro";
import Loading from "../../UI/Loading";
import CatracaRegistroView from "../CatracaRegistroView";
import TablePaginationActions from "../../../shared/components/Table/Actions";
import Button from "../../UI/Button";
import { Link } from "react-router";

const CatracaRegistroListaContainer = () => {
  const [pageCR, setPageCR] = useState({
    content: [],
    size: 0,
    totalElements: 0,
    number: 0,
  });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchData(0);
  }, []);

  const fetchData = (pageNumber) => {
    setIsLoading(true);
    findCatracaRegistroAll(pageNumber).then((data) => {
      if (data) {
        if (data.error) {
          errorMessage(data.message);
        } else {
          setPageCR(data);
        }
      }
      setIsLoading(false);
    });
  };

  const handleChangePage = (event, newPage) => {
    fetchData(newPage);
  };

  return (
    <Container component={Paper}>
      <Grid container direction="column" spacing={3}>
        <Grid>
          <Typography variant="h5">Monitor de Acesso Lista</Typography>
        </Grid>
        <Grid>
          <Button color="secondary" component={Link} to="/monitor-acesso-menu">
            Voltar para o Menu
          </Button>
        </Grid>
        <TablePagination
          rowsPerPageOptions={[]}
          rowsPerPage={pageCR.size ? pageCR.size : 0}
          component="div"
          count={pageCR.totalElements}
          page={pageCR.number}
          onPageChange={handleChangePage}
          labelDisplayedRows={({ from, to, count }) =>
            from +
            "-" +
            to +
            " de " +
            (count !== -1 ? count + " registros" : +" mais de " + to)
          }
          ActionsComponent={TablePaginationActions}
        />
        <Grid container direction="row" spacing={3}>
          {isLoading ? (
            <Grid size={12}>
              <Loading description="Carregando Registros..." />
            </Grid>
          ) : (
            <>
              {pageCR.content.map((catracaRegistro) => (
                <Grid size={6}>
                  <CatracaRegistroView catracaRegistro={catracaRegistro} />
                </Grid>
              ))}
            </>
          )}
        </Grid>
        <TablePagination
          rowsPerPageOptions={[]}
          rowsPerPage={pageCR.size ? pageCR.size : 0}
          component="div"
          count={pageCR.totalElements}
          page={pageCR.number}
          onPageChange={handleChangePage}
          labelDisplayedRows={({ from, to, count }) =>
            from +
            "-" +
            to +
            " de " +
            (count !== -1 ? count + " registros" : +" mais de " + to)
          }
          ActionsComponent={TablePaginationActions}
        />
      </Grid>
    </Container>
  );
};

export default CatracaRegistroListaContainer;
